module.exports = __webpack_public_path__ + "static/media/Popeyes.f9ae1bcf.svg";